import { defineStore } from 'pinia';
import { onRequestDefaultError, requests, removeNulls } from '🔗/utils/requests';

const useLicensesApi = defineStore('licenses-api', {
    state: () => ({
        defaultProfileImage: {
            resized: new URL(`🔗/assets/img/licenses/resized.jpg`, import.meta.url).href,
            original: new URL(`🔗/assets/img/licenses/original.jpg`, import.meta.url).href
        }
    }),
    getters: {
        tracks: (state) => ({
            list: state.getTrackLicenses,
            add: state.addTrackLicence,
            update: state.updateTrackLicence,
            remove: state.removeTrackLicence
        }),
        providers: (state) => ({
            list: state.getProvidersList,
            get: state.getProvider,
            add: state.addProvider,
            updateProfileImage: state.updateProviderProfileImage,
            update: state.updateProvider,
            remove: state.removeProvider
        })
    },
    actions: {
        // Provider
        async getProvidersList(params = {}) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: '/license/list',
                    params,
                    // signal: requests.signal('license-provider-list/')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async getProvider(id) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/license/${ id }`,
                    signal: requests.signal('licenses-provider-get', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateProviderProfileImage(id, file) {
            const formData = new FormData();
            formData.append('image', file);

            try {
                const result = await this.$http({
                    method: 'POST',
                    url: `/license/${id}/profile_image/`,
                    formData,
                    contentType: 'multipart/form-data',
                    signal: requests.signal('license-providers-profile-image', id)
                });

                if ([200, 201].indexOf(result.status) !== -1) {
                    return result.data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async addProvider(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/license/create/',
                    data: removeNulls(data),
                    // signal: requests.signal('playlist-create')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateProvider(id, data) {
            try {
                const result = await this.$http({
                    method: 'PUT',
                    url: `/license/${ id }`,
                    data,
                    signal: requests.signal('license-providers-update', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeProvider(id) {
            try {
                const result = await this.$http({
                    method: 'DELETE',
                    url: `/license/${ id }`,
                    signal: requests.signal('license-provider-remove', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },

        // Track
        async getTrackLicenses(id) {
            try {
                const result = await this.$http({
                    method: 'GET',
                    url: `/license/track/${ id }`,
                    signal: requests.signal('tracks-license-get', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },

        async addTrackLicence(data) {
            try {
                const result = await this.$http({
                    method: 'POST',
                    url: '/license/track/create',
                    data: removeNulls(data),
                    // signal: requests.signal('license-track-add')
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async updateTrackLicence(id, data) {
            try {
                const result = await this.$http({
                    method: 'PUT',
                    url: `/license/track/${ id }`,
                    data,
                    signal: requests.signal('license-track-update', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                } else {
                    onRequestDefaultError({ response: result });
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        },
        async removeTrackLicence(id) {
            try {
                const result = await this.$http({
                    method: 'DELETE',
                    url: `/license/track/${ id }`,
                    signal: requests.signal('license-track-remove', id)
                });

                if (result.status === 200) {
                    const { data } = result;

                    return data;
                }
            } catch (e) {
                onRequestDefaultError(e);
            }
        }
    }
});

export default useLicensesApi;
